import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/finally';
import { Observable } from 'rxjs/Observable';
import { ToastService } from 'libs/mdbootstrap/typescripts/pro';
import { ProcessService } from 'app/core/process/process.service';
import * as Models from 'app/core/models';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import { ModalService } from 'app/modal/modal.service';
import { UserService } from 'app/core/user/user.service';
import { LookupService } from 'app/core/lookup/lookup.service';
import {TranslateService} from '@ngx-translate/core';
import {Title} from '@angular/platform-browser';
import {PageTitleService} from '../shared/helpers/pageTitle.service';

enum titles {
  Likes = 'PROCESS.CATEGORIES.LIKES',
  Recents = 'PROCESS.CATEGORIES.RECENTS',
  Views = 'PROCESS.CATEGORIES.VIEWS',
  Executions = 'PROCESS.CATEGORIES.EXECUTIONS',
  Editing = 'PROCESS.CATEGORIES.EDITING',
  Executing = 'PROCESS.CATEGORIES.EXECUTING',
  Published = 'PROCESS.CATEGORIES.PUBLISHED',
  Archived = 'PROCESS.CATEGORIES.ARCHIVED'
}

@Component({
  selector: 'app-process-categories',
  templateUrl: './processCategories.component.html',
  styleUrls: ['./processCategories.component.scss']
})
export class ProcessCategoriesComponent implements OnInit {

  category: Models.ProcessGroups;
  processPerRow = 4;
  tagId: number;
  isTagCategory = false;

  firstProcesses: Models.Process[];
  firstIsLoading: boolean;
  firstLoading = false;
  firstPageNumber: number;
  firstTotalItemsCount: number;
  firstTitle: string;

  hasMultipleParts = false;
  secondProcesses: Models.Process[];
  secondIsLoading: boolean;
  secondLoading = false;
  secondPageNumber: number;
  secondTotalItemsCount: number;
  secondTitle: string;

  thirdProcesses: Models.Process[];
  thirdIsLoading: boolean;
  thirdLoading = false;
  thirdPageNumber: number;
  thirdTotalItemsCount: number;
  thirdTitle: string;

  forthProcesses: Models.Process[];
  forthIsLoading: boolean;
  forthLoading = false;
  forthPageNumber: number;
  forthTotalItemsCount: number;
  forthTitle: string;

  createdByImageUrl: boolean;
  forthdIsLoading: boolean;

  private PAGE_SIZE = 20;

  constructor(private processService: ProcessService,
              private authenticationService: AuthenticationService,
              private router: Router,
              private actRoute: ActivatedRoute,
              private modalService: ModalService,
              private ngZone: NgZone,
              private toastService: ToastService,
              private userService: UserService,
              private lookupService: LookupService,
              private titleService: Title,
              private pageTitleService: PageTitleService,
              private translateService: TranslateService) {

    window.onresize = () => {
      this.onResize();
    };
  }

  ngOnInit() {
    this.firstProcesses = [];
    this.firstPageNumber = 0;
    this.secondProcesses = [];
    this.thirdPageNumber = 0;
    this.thirdProcesses = [];
    this.forthPageNumber = 0;
    this.forthProcesses = [];
    this.secondPageNumber = 0;
    this.processPerRow = this.calculateProcessPerRow();
    this.hasMultipleParts = false;
    this.isTagCategory = false;

    const categoryId: number = +this.actRoute.snapshot.paramMap.get('categoryId');

    if (categoryId !== null) {
      this.category = <Models.ProcessGroups>categoryId;

      if (this.category !== null) {

        switch (+this.category) {
          case Models.ProcessGroups.Likes:
            this.firstTitle = titles.Likes;
            break;
          case Models.ProcessGroups.Recents:
            this.firstTitle = titles.Recents;
            break;
          case Models.ProcessGroups.Views:
            this.firstTitle = titles.Views;
            break;
          case Models.ProcessGroups.Executions:
            this.firstTitle = titles.Executions;
            break;
          case Models.ProcessGroups.Editing:
            this.firstTitle = titles.Editing;
            break;
          case Models.ProcessGroups.Executing:
            this.firstTitle = titles.Executing;
            break;
          case Models.ProcessGroups.EditingAndExecuting:
            this.firstTitle = titles.Executing;
            this.PAGE_SIZE = 4;

            this.hasMultipleParts = true;
            this.secondTitle = titles.Editing;
            this.thirdTitle = titles.Published;
            this.forthTitle = titles.Archived;
            break;
          case Models.ProcessGroups.Tags:
            const tagId: number = +this.actRoute.snapshot.paramMap.get('tagId');

            if (tagId) {
              this.tagId = tagId;
              this.isTagCategory = true;
            } else {
              this.category = null;
            }
            break;
          default:
            this.category = null;
            break;
        }
      }
      if (this.category !== null) {
        if (!this.isTagCategory) {
          this.firstLoading = true;
          this.getFirstProcesses();

          if (this.hasMultipleParts) {
            this.secondLoading = true;
            this.getSecondProcesses();

            this.thirdLoading = true;
            this.getThirdProcesses();

            this.forthLoading = true;
            this.getForthProcesses();
          }

          this.translatePageTitle();
        } else {
          this.getTagCategory();
        }
      }
    }
  }

  private translatePageTitle() {
    const titleKey = this.actRoute.data['value'].titleKey;
    if (titleKey) {
      if (this.isTagCategory) {
        this.pageTitleService.setTitle(titleKey, this.firstTitle);
      } else if (this.hasMultipleParts) {
        this.translateService.get( 'PROCESS.CATEGORIES.MY_PROCESSES_PAGE_TITLE').subscribe((pageTitle) => {
          this.pageTitleService.setTitle(pageTitle);
        });
      } else {
        this.translateService.get(this.firstTitle).subscribe((categoryName) => {
          this.pageTitleService.setTitle(titleKey, categoryName);
        });
      }
    }
  }

  get isAuthenticated(): boolean {
    return this.authenticationService.isAuthenticated();
  }

  get moreFirstProcessesLeft(): boolean {
    return this.firstProcesses.length > 0 && this.firstProcesses.length < this.firstTotalItemsCount;
  }

  get moreSecondProcessesLeft(): boolean {
    return this.secondProcesses.length > 0 && this.secondProcesses.length < this.secondTotalItemsCount;
  }

  get moreThirdProcessesLeft(): boolean {
    return this.thirdProcesses.length > 0 && this.thirdProcesses.length < this.thirdTotalItemsCount;
  }

  get moreForthProcessesLeft(): boolean {
    return this.forthProcesses.length > 0 && this.forthProcesses.length < this.forthTotalItemsCount;
  }

  get firstDataSource(): Observable<Models.PagedList<Models.Process>> {
    switch (+this.category) {
      case Models.ProcessGroups.Likes:
      case Models.ProcessGroups.Recents:
      case Models.ProcessGroups.Views:
      case Models.ProcessGroups.Executions:
        return this.processService.getGroups(this.category, this.PAGE_SIZE, this.firstPageNumber + 1);

      case Models.ProcessGroups.EditingAndExecuting:
      case Models.ProcessGroups.Executing:
        return this.processService.getExecutingProcesses(this.PAGE_SIZE, this.firstPageNumber + 1);

      case Models.ProcessGroups.Editing:
        return this.processService.getEditingProcesses(this.PAGE_SIZE, this.firstPageNumber + 1);

      case Models.ProcessGroups.Tags:
        return this.processService.getTagCategoryProcesses(this.tagId, this.PAGE_SIZE, this.firstPageNumber + 1);
    }
  }

  get secondDataSource(): Observable<Models.PagedList<Models.Process>> {
    return this.processService.getEditingProcesses(this.PAGE_SIZE, this.secondPageNumber + 1);
  }

  get thirdDataSource(): Observable<Models.PagedList<Models.Process>> {
    return this.processService.getMyPublishedProcesses(this.PAGE_SIZE, this.thirdPageNumber + 1);
  }

  get forthDataSource(): Observable<Models.PagedList<Models.Process>> {
    return this.processService.getMyArchivedProcesses(this.PAGE_SIZE, this.forthPageNumber + 1);
  }

  getFirstProcesses(): void {
    this.firstIsLoading = true;
    this.firstDataSource
      .finally(() => {
        this.firstIsLoading = false;
        this.firstLoading = false;
      })
      .subscribe((result: Models.PagedList<Models.Process>) => {
        this.firstPageNumber = result.pageNumber;
        this.firstTotalItemsCount = result.totalItemsCount;
        this.addnewItemsTotList(result.items, this.firstProcesses);
      });
  }

  getSecondProcesses(): void {
    this.secondIsLoading = true;
    this.secondDataSource
      .finally(() => {
        this.secondIsLoading = false;
        this.secondLoading = false;
      })
      .subscribe((result: Models.PagedList<Models.Process>) => {
        this.secondPageNumber = result.pageNumber;
        this.secondTotalItemsCount = result.totalItemsCount;
        this.addnewItemsTotList(result.items, this.secondProcesses);
      });
  }

  getThirdProcesses(): void {
    this.thirdIsLoading = true;
    this.thirdDataSource
      .finally(() => {
        this.thirdIsLoading = false;
        this.thirdLoading = false;
      })
      .subscribe((result: Models.PagedList<Models.Process>) => {
        this.thirdPageNumber = result.pageNumber;
        this.thirdTotalItemsCount = result.totalItemsCount;
        this.addnewItemsTotList(result.items, this.thirdProcesses);
      });
  }

  getForthProcesses(): void {
    this.forthIsLoading = true;
    this.forthDataSource
      .finally(() => {
        this.forthIsLoading = false;
        this.forthLoading = false;
      })
      .subscribe((result: Models.PagedList<Models.Process>) => {
        this.forthPageNumber = result.pageNumber;
        this.forthTotalItemsCount = result.totalItemsCount;
        this.addnewItemsTotList(result.items, this.forthProcesses);
      });
  }

  getTagCategory(): void {

    this.lookupService.getTagCategories()
      .finally(() => {})
      .subscribe((tagCategories: Array<Models.TagCategory>) => {
        const tagCategory: Models.TagCategory = tagCategories.find(x => x.tagId === this.tagId);
        if (tagCategory != null) {
          this.firstLoading = true;
          this.firstTitle = tagCategory.categoryTitle;
          this.getFirstProcesses();
          this.translatePageTitle();
        }
      });

  }

  addnewItemsTotList(items: Array<Models.Process>, list: Array<Models.Process>): void {
    items.forEach(element => {
      if (list.find(x => x.processId === element.processId) == null) {
        element.color = this.randomColor();
        element.createdByInitials = element.createdBy ?
                                    element.createdBy.split(' ')
                                      .map((n: string) => n.substr(0, 1))
                                      .slice(0, 2).join('') : '';
        list.push(element);
      }
    });
  }

  randomColor(): string {
    return (Math.floor(Math.random() * (6)) + 1).toString();
  }

  preview(processId: number, processName?: string) {
    if (!this.isAuthenticated) {
      const data: Models.ModalContext = {
        modalType: Models.ModalType.SIGN_UP,
        modalAction: Models.ModalAction.OPEN,
        parameters: []
      };
      this.modalService.command(data);
    } else {
      if (processName.trim()) {
        this.router.navigate(['/process/preview/', processId, processName]);
      } else {
        this.router.navigate(['/process/preview/', processId]);
      }
    }
  }

  run($event: Event, processId: number) {
    $event.stopPropagation();
    if (!this.isAuthenticated) {
      const data: Models.ModalContext = {
        modalType: Models.ModalType.SIGN_UP,
        modalAction: Models.ModalAction.OPEN,
        parameters: []
      };
      this.modalService.command(data);
    } else {
      this.router.navigate(['/process/execute/', processId]);
    }
  }

  edit($event: Event, processId: number) {
    $event.stopPropagation();
    if (!this.isAuthenticated) {
      const data: Models.ModalContext = {
        modalType: Models.ModalType.SIGN_UP,
        modalAction: Models.ModalAction.OPEN,
        parameters: []
      };
      this.modalService.command(data);
    } else {
      this.router.navigate(['/process/editing/', processId]);
    }
  }

  calculateProcessPerRow(): number {
    const width = window.innerWidth;
    let newprocessPerRow;
    if (width >= 1200) {
      newprocessPerRow = 4;
    } else if (width >= 500) {
      newprocessPerRow = 3;
    } else {
      newprocessPerRow = 2;
    }
    return newprocessPerRow;
  }

  onResize() {
    this.processPerRow = this.calculateProcessPerRow();
  }

}






// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/processCategories/processCategories.component.ts